import { render } from "./FeaturedProductCard.vue?vue&type=template&id=24a561d2&scoped=true"
import script from "./FeaturedProductCard.vue?vue&type=script&lang=js"
export * from "./FeaturedProductCard.vue?vue&type=script&lang=js"

import "./FeaturedProductCard.vue?vue&type=style&index=0&id=24a561d2&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a561d2"]])

export default __exports__